const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const warning = require('warning');
const createReactClass = require('create-react-class');

/**
 * TextArea - a vogue wrapper around a text area.
 */

const TextArea = createReactClass({

  propTypes: {
    className: PropTypes.string,
    label: PropTypes.string.isRequired,
    modifiers: PropTypes.arrayOf(
      PropTypes.oneOf([
        'autoExpand',
        'inverse',
        'error',
        'hidesLabel',
      ]),
    ),
    onChange: PropTypes.func,
    value: PropTypes.string,
    valueLink: PropTypes.object,
    helperText: PropTypes.string,
    placeholder: PropTypes.string,
    rows: PropTypes.number,
  },

  getDefaultProps() {
    return {
      modifiers: [],
      rows: 1,
    };
  },

  componentDidMount() {
    if (this.props.modifiers.includes('autoExpand')) {
      this._autoExpand();
    }
  },

  focus() {
    this.refs._textarea.focus();
  },

  blur() {
    this.refs._textarea.blur();
  },

  _autoExpand() {
    this.refs._textarea.style.height = '0px';
    this.refs._textarea.style.height = `${ this.refs._textarea.scrollHeight }px`;
  },

  _onChange(e) {
    if (this.props.modifiers.includes('autoExpand')) {
      this._autoExpand();
    }

    const {
      valueLink,
      onChange,
    } = this.props;

    // route the change event appropriately
    if (onChange) {
      onChange(e);
    } else {
      valueLink.requestChange(e.target.value);
    }
  },

  render() {
    const {
      className,
      modifiers,
      valueLink,
      helperText,
      label,
      rows,
      ...passedProps
    } = this.props;

    const groupClasses = classNames(className, 'TextArea-group', {
      'is-error': modifiers.includes('error'),
    });

    const value = this.props.valueLink ? this.props.valueLink.value : this.props.value;
    const inputClasses = classNames(
      'TextArea',
      { 'is-filled': value },
      ...modifiers.map(m => `TextArea--${ m }`)
    );

    warning(
      !(this.props.label && this.props.placeholder),
      'TextArea received both label and placeholder.'
    );

    warning(
      !(modifiers.includes('autoExpand') && rows !== 1),
      `TextArea received autoExpand modifier but rows was ${ rows } and will be ignored.`
    );

    return (
      <div className={ groupClasses }>
        <textarea
          ref="_textarea"
          className={ inputClasses }
          value={ value }
          onChange={ this._onChange }
          autoFocus={ true }
          rows={ rows }
          { ...passedProps }
        />
        <label className="TextArea-label">{ label }</label>
        { modifiers.includes('error') && helperText ? (
          <div className="TextArea-helper">{ helperText}</div>
        ) : null }
      </div>
    );
  },

});

module.exports = TextArea;
